import { render, staticRenderFns } from "./CellRendererApplicants.vue?vue&type=template&id=231161fe"
import script from "./CellRendererApplicants.vue?vue&type=script&lang=js"
export * from "./CellRendererApplicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports